export class LoginPageImage {
    Id: number;
    ImageName: string = "";
    Comment: string = "";
    Active: boolean = false;
}